﻿export const NOT_FOUND = 'NOT_FOUND'

export const SortDirectionType = {
	ASCENDING: 1,
	DESCENDING: 2
}

export const TaskTargetType = {
    Agent: 'agent',
    Utg: 'utg'
}
export const TaskTargetTypeUtg = {
    Configuration: 'configuration',
    DeployUtgVersion: 'deployUtgVersion',
    Miscellaneous: 'miscellaneous',
    SetOffline: 'setOffline',
    StartStop: 'startstop',
    UploadLogs: 'uploadLogs'
}

export const TaskTargetTypeUtgConfiguration = {
    UpdateUtg: 'push',
    RollbackUtg: 'rollback',
    UpdateCommandCenter: 'pull'
}

export const TaskTargetTypeUtgStartStop = {
    Restart: 'restart',
    Start: 'start',
    Stop: 'stop'
}

export const TaskTargetTypeUtgMiscellaneous = {
    ResetSerialSlot: 'resetSerialSlot'
}

export const TaskTargetTypeAgent = {
    DeployAgentVerson: 'deployAgentVersion',
    UploadLogs: 'uploadLogs'
}

export const TaskType = {
    unknown: 0,
    start: 1,
    stop: 2,
    restart: 3,
    push: 4, // update config
    rollback: 5, // sync config
    pull: 5, // same as sync but differences are in the task instructions
    updateComponentInfo: 6,
    resetSerialSlot: 7,
    deployUtgVersion: 8,
    deployAgentVersion: 9,
    UpdateDeviceForms: 10,
    UpdateDeviceFirmware: 11,
    setOffline: 13,
    uploadLogs: 15,
}

export const UserRoles = {
	ReadOnly: 10000,
	Manager: 10001,
	TechnicalAdvisor: 10002,
	Technician: 10003,
	HelpDesk:10004
}

export const UserTypes = {
	Standard: 0,
	System: 1,
	Ephemeral: 2
}

export const UserPermissions = {
	canView: 'canView',
	canEdit: 'canEdit',
	canDelete: 'canDelete',
	isEnabled: 'isEnabled',
	canGrant: 'canGrant'
}

export const ComponentDeviceType = {
	Unknown: 0,

	// Ingenico
	iPP320CAN: 1,
	iCM122RBA: 2,
	iMP352RBA: 3,
	iMP627RBA: 4,
	iMP657RBA: 5,
	iPP320RBA: 6,
	iPP350RBA: 7,
	iSC250RBA: 8,
	iSC350RBA: 9,
	iSC480RBA: 10,
	iWL250RBA: 11,
	iWL252RBA: 12,
	iWL258RBA: 13,
	iUP250RBA: 14,
	iUC285RBA: 15,
	L3000RBA: 16,
	L3600RBA: 24,
	L5000RBA: 17,
	L7000RBA: 18,
	L8000RBA: 19,
	LK2500iRBA: 20,
	Link2500: 20,
	M5000RBA: 21,
	Move5000: 21,

	// Verifone
	Mx915P2PE: 22,
	Mx925P2PE: 23,

	Self2000: 25,
	S2000: 25,
	Self2000LE: 25,
	S2000LE: 25,
	Self3000: 26,
	S3000: 26,
	Self4000: 27,
	S4000: 27,
	Self4000LE: 27,
	S4000LE: 27,
	Self5000: 28,
	S5000: 28,
	Self5000LE: 28,
	S5000LE: 28,
	Self70008000: 29,
	S70008000: 29
}

export const ComponentDeviceTypeFormsUnsupported = {
	mx915p2pe: true,
	mx925p2pe: true,
	paxbroadpos: true
}

// export const BusinessEntityType = {
// 	Unknown: 0,
// 	Merchant: 1,
// 	Organization: 2,
// 	OrganizationUnit: 2,
// 	Reseller: 3
// }
export const BusinessEntityType = {
	Unknown: 0,
	Merchant: 1,
	Organization: 2,
	OrganizationUnit: 2,
	Reseller: 3
}

export const OrganizationType = {
	Standard: 1,
	Root: 2,
	Reseller: 3
}

export const UserSettingsType = {
	UtgListFilters: 'previouslySelectedUtgFilters',
	TaskListFilters: 'previouslySelectedTaskFilters',
	DeviceListFilters: 'previouslySelectedDeviceFilters',
	PageSize: 'pagesize',
	ShowTree: 'showtree',
	SidebarWidth: 'sidebarwidth',
	Debug: 'debug',
	SelectedBusinessEntityId: 'selectedBusinessEntityId'
}

export const ComponentInterfaceType = {
	Unknown: 0,
	TcpIp: 30,
	Utg4Cloud: 109,
	TcpIpSsl: 110,
	Http: 111,
	HttpSsl: 112,
	MicrosApi: 114,
	SimphonyApi: 115,
	SerialApiAscii: 116,
	SerialApiBinary: 117,
	FileApi: 120,
	TweenApi: 121,
	Utg4CloudSsl: 137,
	OraclePaymentInterface: 148,
	Rest: 154,
	Opera: 158
}

export const TaskStatus = {
	Rejected: -10,
	ControllerFailed: -5,
	Requested: 0,
	Accepted: 5,
	Planned: 10,
	Scheduled: 15,
	Completed: 20,
	Failed: 30
}

export const HardCodedCurrencies = [
	{
		"id": 1,
		"currencyCode": "124",
		"abbreviation": "CAD",
		"symbol": "$",
		"name": "Canadian Dollar"
	},
	{
		"id": 2,
		"currencyCode": "840",
		"abbreviation": "USD",
		"symbol": "$",
		"name": "United States Dollar"
	},
	{
		"id": 3,
		"currencyCode": "484",
		"abbreviation": "MXN",
		"symbol": "$",
		"name": "Mexican Peso"
	},
	{
		"id": 4,
		"currencyCode": "951",
		"abbreviation": "XCD",
		"symbol": "$",
		"name": "East Caribbean Dollar"
	},
	{
		"id": 5,
		"currencyCode": "136",
		"abbreviation": "KYD",
		"symbol": "$",
		"name": "Cayman Islands Dollar"
	},
	{
		"id": 6,
		"currencyCode": "388",
		"abbreviation": "JMD",
		"symbol": "J$",
		"name": "Jamaican Dollar"
	},
	{
		"id": 7,
		"currencyCode": "052",
		"abbreviation": "BBD",
		"symbol": "$",
		"name": "Barbados Dollar"
	},
	{
		"id": 8,
		"currencyCode": "044",
		"abbreviation": "BSD",
		"symbol": "$",
		"name": "Bahamian Dollar"
	},
	{
		"id": 10,
		"currencyCode": "188",
		"abbreviation": "CRC",
		"symbol": "�",
		"name": "Costa Rican Colon"
	},
	{
		"id": 11,
		"currencyCode": "060",
		"abbreviation": "BMD",
		"symbol": "$",
		"name": "Bermudian Dollar"
	}
]

export const SystemUserType = {
	Service: 'serviceUsers',
	Ephemeral: 'ephemeralUsers'
}

//when the user's session has this many seconds remaining, the InactivityModal is displayed
export const SESSION_TIMEOUT_INTERVAL = 300

export const InstallationType = {
	New: 10,
	Upgrade: 20,
	Existing: 30,
	Reinstall: 40
}

export const RoleMasks = {
	Universal: 1,
	Root: 2,
	Reseller: 4,
	Organization: 8,
	Merchant: 16
}

export const RoleType = {
	Global: 1,
	Custom: 2
}

export const LifespanType = {
	Unknown:0,
	EndDateTime: 10,
	Window:20,
	SingleUse:30
}